export default "__VITE_ASSET__DgHEx20Z__"